
import Navbar from "@/components/Navbar";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";

const domains = [
  {
    symbol: "Engineering Services",
    name: "Engineering Services",
    categories: "Design, Technical Solutions, Systems Integration, Specifications Development"
  },
  {
    symbol: "Development/Finance",
    name: "Development/Finance",
    categories: "Project Development, Investment Strategy, Financial Planning, Risk Management"
  },
  {
    symbol: "Integrated EPC",
    name: "Integrated EPC",
    categories: "Project Integration, Lifecycle Management, Value Engineering, Stakeholder Management"
  },
  {
    symbol: "Master Planning",
    name: "Master Planning",
    categories: "Site Analysis, Infrastructure Planning, Facility Layout, Development Strategy"
  },
  {
    symbol: "Modularization",
    name: "Modularization",
    categories: "Module Design, Assembly Planning, Transportation Logistics, Installation Strategy"
  },
  {
    symbol: "Procurement",
    name: "Procurement",
    categories: "Supply Chain Management, Vendor Selection, Contract Management, Materials Control"
  },
  {
    symbol: "Startup & Operations",
    name: "Startup & Operations",
    categories: "Commissioning, Performance Testing, Training, Operational Support"
  },
  {
    symbol: "Technology Licensing",
    name: "Technology Licensing",
    categories: "Technology Assessment, Implementation Strategy, Process Integration, Performance Optimization"
  },
  {
    symbol: "Tunneling",
    name: "Tunneling",
    categories: "Underground Construction, TBM Operations, Ground Support, Safety Systems"
  },
  {
    symbol: "Sustainability Services",
    name: "Sustainability Services",
    categories: "Environmental Planning, Green Technologies, Carbon Reduction, Resource Efficiency"
  }
];

const BechtelChannel = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-muted">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Card className="mb-6">
          <CardHeader>
            <div className="flex items-center gap-6">
              <img 
                src="/lovable-uploads/2165ebae-a37b-42c5-9e9f-7874496c2348.png" 
                alt="Bechtel Logo" 
                className="w-24 h-24 object-contain"
              />
              <div>
                <CardTitle className="text-2xl font-bold mb-2">{t('bechtel.title')}</CardTitle>
                <CardDescription className="text-lg">
                  {t('bechtel.description')}
                </CardDescription>
                <Button 
                  variant="link" 
                  className="p-0 h-auto text-primary hover:text-primary/80 flex items-center gap-2"
                  onClick={() => window.open('https://www.bechtel.com/', '_blank')}
                >
                  {t('bechtel.visitWebsite')}
                  <ExternalLink className="h-4 w-4" />
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent className="space-y-6">
            <div 
              onClick={() => window.open('https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/e6c0c6d8-7217-48e7-93d6-9a8dfdcf63d7/iSPAI%20Industry_EPC.pdf?ver=1737059693348', '_blank')}
              className="bg-white border-2 border-black p-4 rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
            >
              <h3 className="text-xl font-semibold text-center">{t('bechtel.industryTemplate')}</h3>
            </div>

            <h2 className="text-xl font-semibold mb-4">{t('bechtel.domainElements')}</h2>
            <div className="grid grid-cols-5 gap-2">
              {domains.map((domain) => (
                <TooltipProvider key={domain.symbol}>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="bg-primary text-primary-foreground p-4 rounded-lg cursor-help transition-all duration-200 hover:scale-105 hover:bg-black hover:shadow-lg">
                        <div className="text-sm font-medium text-center">{domain.name}</div>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent className="bg-white text-black border border-gray-200">
                      <p className="font-semibold mb-1">{domain.name}</p>
                      <p className="text-sm">{domain.categories}</p>
                    </TooltipContent>
                  </Tooltip>
                </TooltipProvider>
              ))}
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default BechtelChannel;
